var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 0.73291C28.9667 0.73291 29.7502 1.51641 29.7502 2.48291V53.8162C29.7502 54.7827 28.9667 55.5662 28.0002 55.5662C27.0337 55.5662 26.2502 54.7827 26.2502 53.8162V2.48291C26.2502 1.51641 27.0337 0.73291 28.0002 0.73291Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0835 17.6496C11.0835 10.884 16.568 5.39958 23.3335 5.39958H40.833L40.8334 8.89958H23.3335C18.501 8.89958 14.5835 12.817 14.5835 17.6496C14.5835 22.4821 18.501 26.3996 23.3335 26.3996C24.3 26.3996 25.0835 27.1831 25.0835 28.1496C25.0835 29.1161 24.3 29.8996 23.3335 29.8996C16.568 29.8996 11.0835 24.4151 11.0835 17.6496ZM42.5835 7.14958C42.5835 8.11608 41.7999 8.89958 40.8334 8.89958L40.833 5.39958C41.7995 5.39958 42.5835 6.18308 42.5835 7.14958Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5835 28.1496C21.5835 27.1831 22.367 26.3996 23.3335 26.3996H32.6668C39.4324 26.3996 44.9168 31.884 44.9168 38.6496C44.9168 45.4151 39.4324 50.8996 32.6668 50.8996H15.1674L15.167 47.3996H32.6668C37.4994 47.3996 41.4168 43.4821 41.4168 38.6496C41.4168 33.817 37.4994 29.8996 32.6668 29.8996H23.3335C22.367 29.8996 21.5835 29.1161 21.5835 28.1496ZM13.4168 49.1496C13.4168 48.1831 14.2005 47.3996 15.167 47.3996L15.1674 50.8996C14.2009 50.8996 13.4168 50.1161 13.4168 49.1496Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_15146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0 0.149658)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.02d67bf6.svg";
export { ForwardRef as ReactComponent };